import { motion } from 'motion/react';
import { site } from '../data/site';
import { useScroll } from '../hooks/useScrollContext';
import MotionButton from '../ui/MotionButton';
import {
  staggerContainer,
  staggerItem,
  usePrefersReducedMotion,
} from '../effects/motionConfig';

function splitName(name) {
  const parts = name.trim().split(/\s+/);
  if (parts.length < 2) return { first: name, last: '' };
  return { first: parts[0], last: parts.slice(1).join(' ') };
}

export default function HeroSection() {
  const { scrollToSection } = useScroll();
  const reduced = usePrefersReducedMotion();
  const { first, last } = splitName(site.name);

  const content = (
    <div className="hero-section__grid">
      <div className="hero-section__lead">
        <p className="hero-section__role">{site.role}</p>
        <h1 className="hero-section__title">
          <span className="hero-section__title-line">{first}</span>
          {last && <span className="hero-section__title-line hero-section__title-line--stroke">{last}</span>}
        </h1>
        <p className="hero-section__tagline">{site.tagline}</p>
      </div>
      <aside className="hero-section__aside">
        <ul className="hero-section__focus-list">
          {site.focusAreas.map((area) => (
            <li key={area}>{area}</li>
          ))}
        </ul>
        <div className="hero-section__actions">
          <MotionButton className="btn btn--primary btn--lg" onClick={() => scrollToSection('projects')}>
            View projects
          </MotionButton>
          <MotionButton className="btn btn--outline btn--lg" onClick={() => scrollToSection('contact')}>
            Get in touch
          </MotionButton>
        </div>
      </aside>
    </div>
  );

  if (reduced) {
    return (
      <section id="hero" className="section hero-section">
        {content}
        <div className="hero-section__rule" aria-hidden="true" />
      </section>
    );
  }

  return (
    <section id="hero" className="section hero-section">
      <motion.div
        className="hero-section__grid"
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="hero-section__lead" variants={staggerItem}>
          <p className="hero-section__role">{site.role}</p>
          <h1 className="hero-section__title">
            <span className="hero-section__title-line">{first}</span>
            {last && <span className="hero-section__title-line hero-section__title-line--stroke">{last}</span>}
          </h1>
          <p className="hero-section__tagline">{site.tagline}</p>
        </motion.div>
        <motion.aside className="hero-section__aside" variants={staggerItem}>
          <ul className="hero-section__focus-list">
            {site.focusAreas.map((area) => (
              <li key={area}>{area}</li>
            ))}
          </ul>
          <div className="hero-section__actions">
            <MotionButton className="btn btn--primary btn--lg" onClick={() => scrollToSection('projects')}>
              View projects
            </MotionButton>
            <MotionButton className="btn btn--outline btn--lg" onClick={() => scrollToSection('contact')}>
              Get in touch
            </MotionButton>
          </div>
        </motion.aside>
      </motion.div>
      <motion.div
        className="hero-section__rule"
        aria-hidden="true"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.35 }}
      />
    </section>
  );
}
